import React, { useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import {
  HttpService,
  API,
  swal,
  Title,
  toast,
  Messages,
  DateFormat,
  Spinner
} from '../../config/react'
import UserContext from '../../config/UserContext'
import DataTable from 'react-data-table-component'
const Blogs = () => {
  const [BlogList, setBlogList] = useState([])
  const user = useContext(UserContext)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const DefaultFilters = {
    page: 1,
    // search: '',
    page_size: 10,
    sort_column: '',
    sort_direction: ''
  }
  const [SearchTerm, setSearchTerm] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const [totalRows, settotalRows] = useState()
  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
  }
  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Title"
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) =>
          setTimeout(() => {
            setSearchTerm(e.target.value)
          }, 1000)
        }
      />
    )
  })
  const columns = [
    {
      name: 'Title',
      selector: (row) => row.title,
      sortable: true,
      sortField: 'title'
    },
    {
      name: 'Slug',
      selector: (row) => row.slug,
      sortable: true,
      sortField: 'slug'
    },
    {
      name: 'Publish Date',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>,
      sortField: 'created_at',
      sortable: true
    },
    {
      name: 'Status',
      selector: (row) => (row.status === 1 ? <label>Active</label> : <label>Inactive</label>)
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          <Link
            to={'/blog/edit/' + row.id}
            className="text-dark"
            title="Edit"
          >
            <i
              className="fa fa-pencil-square-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
          <Link
            onClick={(e) => DeleteBlog(e, row.id)}
            to=""
            className="text-dark"
            title="Delete"
          >
            <i
              className="fa fa-trash-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
        </div>
      )
    }
  ]
  useEffect(() => {
    setIsAuth(true)
    document.title = Title.Blogs
    GetBlogsList()
  }, [CustomFilters, SearchTerm])

  const GetBlogsList = () => {
    const blogData = {
      page: CustomFilters.page,
      search: SearchTerm,
      page_size: CustomFilters.page_size,
      sort_column: CustomFilters.sort_column,
      sort_direction: CustomFilters.sort_direction
    }
    setLoading(true)
    HttpService.postApi(API.GetBlogs, blogData).then((response) => {
      setLoading(false)
      if (response.data.status === true && response.data.result !== '') {
        const data = response.data.result
        setBlogList(data[1])
        setForceUpdate(!isForceUpdate)
        settotalRows(response.data.result[0][0].total)
      } else {
        setBlogList([])
        settotalRows(0)
      }
    })
  }
  const DeleteBlog = async (e, id) => {
    e.preventDefault()
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          id,
          IsDeleted: true,
          deleted_by: user.id
        }
        setLoading(true)
        HttpService.postApi(API.DeleteBlog, param).then((response) => {
          setLoading(false)
          toast.success(Messages.RecordDeleted)
          GetBlogsList()
          setForceUpdate(!isForceUpdate)
        })
      }
    })
  }
  const handleSort = (e, direction) => {
    // console.log('LN 127 Sort FIeld ' + e.sortField)
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
  }

  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.Blogs} </h3>
        <div className="btn-group">
          <Link
            to="/blog/add"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            {Title.AddBlog}{' '}
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={BlogList}
                  pagination
                  persistTableHead={true}
                  paginationServer
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  onSort={handleSort}
                  progressPending={loading}
                  progressComponent={<Spinner />}
                  paginationDefaultPage={currentPage}
                  subHeaderComponent={subHeaderComponentMemo}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Blogs
